import React, { ChangeEvent, useState } from 'react';
import {
  Box,
  TextField,
  FormControl,
  FormHelperText,
  Typography,
  Switch,
  FormControlLabel,
  Slider,
  Button
} from '@mui/material';
import { CsvTool } from '../../../Shared-ui/Types/Tool';
import { useDispatch } from 'react-redux';
import { StartLoading, StopLoading } from '../../../Shared-ui/Store/LoadingReducer/LoaderActions';
import { TOOLKIT } from '../../../Services/Endpoint';
import BaseInstance from '../../../Services/AxiosInstance/BaseInstance';
import { ShowError } from '../../../Shared-ui/Store/MessageReducer/MsgActions';
import { isOnlyAlphabets, isOnlyAlphabetsNumbers } from '../../../Shared-ui/utils/Common/Common';

interface MyComponentProps {
  handleClose: () => void
}

const CSVTools: React.FC<MyComponentProps> = (props) => {
  const toolErrIntial = {
    name: { error: "", value: false },
    description: { error: "", value: false }
  }
  const toolInitial: CsvTool = {
    name: '',
    description: '',
    type: 'toolkit',
    is_active: true,
    config: {
      max_length: 0,
      toolkit_type: "csvTool"
    },

  }
  const [tools, setTools] = useState<CsvTool>(toolInitial);
  const [toolsErr, setToolsErr] = useState(toolErrIntial);
  const dispatch = useDispatch()

  const handleCreateTool = async () => {
    if (!validateTool()) return
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.post(TOOLKIT, tools).then(
        (res) => res?.data
      );
      handleCancel()
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }


  }
  const validateTool = () => {
    var count = 0

    if (!tools.name.trim() || !isOnlyAlphabetsNumbers(setToolsErr.name.trim())) {
      setToolsErr(preVal => ({ ...preVal, name: { error: "Please enter the name A-z", value: true } }))
      count += 1
    } else {
      setToolsErr(preVal => ({ ...preVal, name: { error: "", value: false } }))
    }

    if (!tools.description.trim()) {
      setToolsErr(preVal => ({ ...preVal, description: { error: "Please enter the description", value: true } }))
      count += 1
    } else {
      setToolsErr(preVal => ({ ...preVal, description: { error: "", value: false } }))
    }

    return count > 0 ? false : true
  }

  const handleCancel = () => {
    setTools(toolInitial)
    props.handleClose()
  }


  const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target
    setTools(preVal => ({ ...preVal, [name]: value }))
  };


  const handleConfigChange = (value: any) => {
    setTools(preVal => ({
      ...preVal, config: {
        max_length: value
      },
    }))
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <FormControl fullWidth error={toolsErr.name.value}>
        <TextField
          label="Tool Name"
          name="name"
          value={tools.name}
          onChange={handleChange}
          inputProps={{ maxLength: 50 }}
          variant="outlined"
          helperText={toolsErr.name.error}
          error={toolsErr.name.value}
          fullWidth
        />
      </FormControl>

      <FormControl fullWidth error={toolsErr.description.value}>
        <TextField
          label="Description"
          name="description"
          value={tools.description}
          onChange={handleChange}
          inputProps={{ maxLength: 100 }}
          variant="outlined"
          multiline
          rows={3}
          helperText={toolsErr.description.error}
          error={toolsErr.description.value}
          fullWidth
        />
      </FormControl>
      <Typography variant="body1" gutterBottom>
        Configuration of csv
      </Typography>
      <Box sx={{ mt: 2 }}>
        <Typography gutterBottom>Maximum CSV Files</Typography>
        <Slider
          value={tools?.config?.max_length}
          name="max_length"
          onChange={(_, value) => handleConfigChange(value)}
          min={1}
          max={10}
          step={1}
          marks
          valueLabelDisplay="auto"
          aria-labelledby="csv-files-slider"
        />
        <FormHelperText>
          Maximum number of CSV files that can be uploaded
        </FormHelperText>
      </Box>

      <FormControlLabel
        control={
          <Switch
            checked={tools.is_active}
            name='is_active'
            onChange={(e) => setTools(preVal => ({ ...preVal, [e.target.name]: e.target.checked }))}
          />
        }
        label="Active"
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 2,
          mb: 3
        }}
      >
        <Button
          variant="outlined"
          size="large"
          sx={{ textTransform: "capitalize" }}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disableElevation
          size="large"
          sx={{ textTransform: "capitalize" }}
          onClick={() => handleCreateTool()}
        //disabled={!selected.subTab}
        >
          Create
        </Button>
      </Box>
    </Box>
  );
};

export default CSVTools;